import { watch } from '@nuxtjs/composition-api';
import { initializeGPT } from './gpt';
import { initializeCriteoOnly } from './criteo';
import { initializeTeads } from './teads';
import { initializeMembrana } from './membrana';
import { initializePrebid } from './prebid';
import { initializeGPTWithoutIframe } from './gptWithoutIftame';
import { initializeYandex } from './yandex';
import { initializeIM } from './idealMedia';
import { initializeTessera } from './tessera';
export const loadAdScript = (adArray, ad, options, adConfig, isMobile, user = {}) => {
  if (!adArray) return;
  watch(
    isMobile,
    (isMobileValue) => {
      const device = isMobileValue ? 'mobile' : 'desktop';
      if (options?.devices && !options?.devices.includes(device)) return;
      switch (ad) {
        case 'GPT':
          initializeGPT(adArray, options, adConfig, isMobile, user);
          break;
        case 'Criteo':
          initializeCriteoOnly(adArray, options, adConfig);
          break;
        case 'Teads':
          initializeTeads(adArray, adConfig, isMobile);
          break;
        case 'Membrana':
          initializeMembrana(adArray, adConfig, isMobile);
          break;
        case 'Prebid':
          initializePrebid(adArray, adConfig);
          break;
        case 'Yandex':
          initializeYandex(adArray, isMobile);
          break;
        case 'GPTWithoutIframe':
          initializeGPTWithoutIframe(isMobile);
          break;
        case 'Tessera':
          initializeTessera(adArray, user);
          break;
        case 'IdealMedia':
          initializeIM(adArray);
          break;
      }
    },
    { immediate: true }
  );
};
